/**
 * Vue Router 配置
 * @description 路由管理，使用懒加载优化首屏加载速度
 */

import Vue from 'vue';
import VueRouter from 'vue-router';

// 路由懒加载
const MainLayout = () => import(/* webpackChunkName: "main-layout" */ '@/components/mainLayout');

Vue.use(VueRouter);

// 创建路由实例
const router = new VueRouter({
    mode: 'hash', // 使用 hash 模式，兼容性好
    routes: [
        {
            path: '/',
            name: 'Home',
            meta: { 
                title: '互联造物 - 链接万物，创造未来',
                keepAlive: true // 是否缓存页面
            },
            component: MainLayout
        }
    ],
    // 路由滚动行为
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

// 路由前置守卫
router.beforeEach((to, from, next) => {
    // 设置页面标题
    window.document.title = to.meta.title || '互联造物';
    next();
});

// 路由后置守卫
router.afterEach((to, from) => {
    // 路由切换完成后的操作
});

export default router;
